import Box from "@mui/material/Box";
import useTheme from "@mui/material/styles/useTheme";
import Typography from "@mui/material/Typography";
import React from "react";
import { useTranslation } from "react-i18next";

export default function StatusCard(props: {
  label: string;
  value: number;
  highlight?: boolean;
  enabled: boolean;
}) {
  const { value, label, enabled, highlight } = props;
  const theme = useTheme();
  const { t } = useTranslation();

  const isHighlighted = highlight && value !== 0;

  return (
    <Box
      sx={{
        padding: "4px 8px",
        textAlign: "center",
        borderRadius: "8px",
        backgroundColor: isHighlighted
          ? theme.palette.error.main
          : enabled
            ? theme.palette.grey[300]
            : theme.palette.background.default,
        color: isHighlighted ? theme.palette.common.white : "inherit",
        boxShadow: enabled
          ? "inset 2px 2px 2px rgba(0, 0, 0, 0.2)"
          : "1px 1px 1px rgba(0, 0, 0, 0.1)",
        transform: enabled ? "translateY(1px)" : "none",
        transition: "all 0.2s ease-in-out",
        height: "100%",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        cursor: "pointer",
        userSelect: "none",
      }}
    >
      <Typography variant="body2" sx={{ fontWeight: 400, lineHeight: 1.2 }}>
        {label}
      </Typography>
      <Typography variant="caption" sx={{ fontWeight: 400, lineHeight: 1.2 }}>
        {value} {value === 1 ? t("device") : t("devices")}
      </Typography>
    </Box>
  );
}
